import { render } from "./BlockerManualReason.vue?vue&type=template&id=cc950bec"
import script from "./BlockerManualReason.vue?vue&type=script&lang=js"
export * from "./BlockerManualReason.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__